import { call, put, select, take, takeLatest } from 'redux-saga/effects';
import { AlarmMap } from 'types';
import { alarmsLoadRequest, alarmsLoadSuccess, alarmsLoadFailure, AlarmsLoadRequestAction } from 'actions/alarmActions';
import { getPermissions } from 'selectors/shellSelectors';
import { getTimezoneOffsetCalculator } from 'selectors/serverSelectors';
import { getAlarms } from 'api';
import { handleErrorSaga } from '../app/handleError';
import { SetDateAction } from 'actions/monitoringActions';

export function* setDateWatcher() {
    // Watch for date changes and then trigger a reload of the alarms (if the user has permission to view alarms)
    while (true) {
        const action: SetDateAction = yield take('SET_DATE');
        const { date } = action.payload;
        const { viewAlarms } = yield select(getPermissions);
        if (viewAlarms) {
            yield put(alarmsLoadRequest(date));
        }
    }
}

export function* loadAlarmsRequestWatcher() {
    yield takeLatest('ALARMS_LOAD_REQUEST', loadAlarmsSaga);
}

export function* loadAlarmsSaga(action: AlarmsLoadRequestAction) {
    // Don't even attempt to load alarms if the user doesn't have permission to view alarms
    const { viewAlarms } = yield select(getPermissions);
    if (!viewAlarms) {
        return;
    }

    const utcDate = action.payload;
    const tzOffsetCalculator = yield select(getTimezoneOffsetCalculator);

    let alarmMap: AlarmMap;
    try {
        alarmMap = yield call(getAlarms, utcDate, tzOffsetCalculator);
    }
    catch (err) {
        yield call(handleErrorSaga, err, alarmsLoadFailure);
        return;
    }
    yield put(alarmsLoadSuccess(alarmMap, { utcDate }));
}



// WEBPACK FOOTER //
// ./src/sagas/alarms/loadAlarmsSaga.ts